import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/authContext";
import AlertSuccess from "../components/alertSuccess";
import { useLoading } from "../libs/loadingContext";
import { localStorageConst } from "../helpers/const";
import { useTranslation } from "react-i18next";

export default function Home() {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { setLoading } = useLoading();
  const { t } = useTranslation();

  let successMessage = localStorage.getItem("profileUpdateSuccessMessage");

  let givenName = authContext.attrInfo
    .filter((item) => item.Name === "given_name")
    .map((val) => val.Value);
  let familyName = authContext.attrInfo
    .filter((item) => item.Name === "family_name")
    .map((val) => val.Value);
  let email = authContext.attrInfo
    .filter((item) => item.Name === "email")
    .map((val) => val.Value);
  let phoneNumber = authContext.attrInfo
    .filter((item) => item.Name === "phone_number")
    .map((val) => val.Value);

  function signOutClicked() {
    setLoading(true);
    authContext.signOut();
    localStorage.clear();
    setLoading(false);
    navigate("/");
    localStorage.removeItem("profileUpdateSuccessMessage");
  }

  async function changePasswordClicked() {
    navigate("/change-password");
    localStorage.removeItem("profileUpdateSuccessMessage");
  }

  function changeProfileClicked() {
    navigate("/change-profile");
    localStorage.removeItem("profileUpdateSuccessMessage");
  }

  useEffect(() => {
    localStorage.setItem(localStorageConst.IsSignClicked, true);
    const phoneNumber = authContext.attrInfo.find((attr) => {
      return attr.Name === "phone_number";
    });
    localStorage.setItem("phoneNumber", phoneNumber?.Value);
    const phoneVerified = authContext.attrInfo.find((attr) => {
      return attr.Name === "phone_number_verified";
    });
  });

  return (
    <>
      <div className="content-page">
        <h3
          className={
            successMessage?.length > 0
              ? "process-title success-message-box"
              : "process-title"
          }
        >
          {t("home.loginSecurity")}
        </h3>
        <div className="profile">
          <div className="profile-info">
            <div>
              <div className="info-title">{t("home.nameSurname")}:</div>
              <div className="info">{`${givenName[0]} ${familyName[0]}`}</div>
            </div>
            <div>
              <button
                className="btn btn-update"
                onClick={() => changeProfileClicked()}
              >
                {t("home.edit")}
              </button>
            </div>
          </div>
          <div className="profile-info">
            <div>
              <div className="info-title">{t("home.email")}:</div>
              <div className="info">{email[0]}</div>
            </div>
            <div></div>
          </div>
          <div className="profile-info">
            <div>
              <div className="info-title">{t("home.phoneNumber")}:</div>
              <div className="info">{phoneNumber[0]}</div>
            </div>
            <div></div>
          </div>
          <div className="profile-info">
            <div>
              <div className="info-title">{t("home.password")}:</div>
              <div className="info">**********</div>
            </div>
            <div>
              <button
                className="btn btn-update"
                onClick={() => changePasswordClicked()}
              >
                {t("home.edit")}
              </button>
            </div>
          </div>
        </div>
        <div className="confirm-code logout-box">
          <div>
            <span style={{ display: "inline" }} onClick={signOutClicked}>
              {t("home.logout")}
            </span>
          </div>
        </div>
        {successMessage?.length > 0 && (
          <>
            <AlertSuccess message={successMessage} />
          </>
        )}
      </div>
    </>
  );
}
